import React from 'react';
import type { MarketGroupingMode } from '../../utils/marketGroupUtils';

type MarketDashboardGroupingSwitchProps = {
  mode: MarketGroupingMode;
  onChange: (mode: MarketGroupingMode) => void;
  disabled?: boolean;
};

const MarketDashboardGroupingSwitch: React.FC<MarketDashboardGroupingSwitchProps> = ({
  mode,
  onChange,
  disabled = false,
}) => (
  <div
    className="market-filter-mode-switch"
    role="group"
    aria-label="Режим группировки строк"
    style={disabled ? { opacity: 0.55, pointerEvents: 'none' } : undefined}
  >
    <button
      type="button"
      className={`market-filter-mode-btn ${mode === 'grade' ? 'active' : ''}`}
      onClick={() => onChange('grade')}
      disabled={disabled}
    >
      Роль
    </button>
    <button
      type="button"
      className={`market-filter-mode-btn ${mode === 'cluster' ? 'active' : ''}`}
      onClick={() => onChange('cluster')}
      disabled={disabled}
    >
      Кластер
    </button>
  </div>
);

export default MarketDashboardGroupingSwitch;
